var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TopNavigation", { attrs: { TopAct: "2" } }),
      _vm.$store.state.webNavigator == "pc"
        ? _c("div", [
            _c("div", { staticClass: "aboutProducts" }, [
              _vm._m(0),
              _c("div", { staticClass: "aboutProducts-banner1 positionRE" }, [
                _vm._m(1),
                _c("div", { staticClass: "aP-banner1-nameImgBar" }, [
                  _c("img", {
                    staticClass: "aP-banner1-nameImg aP-nameImg1",
                    attrs: { title: "", src: _vm.src1, alt: "" }
                  }),
                  _c("img", {
                    staticClass: "aP-banner1-nameImg aP-nameImg3",
                    attrs: { title: "", src: _vm.src3, alt: "" }
                  }),
                  _c("img", {
                    staticClass: "aP-banner1-nameImg aP-nameImg4",
                    attrs: { title: "", src: _vm.src4, alt: "" }
                  })
                ])
              ]),
              _c("div", { staticClass: "aboutProducts-banner2 positionRE" }, [
                _vm._m(2),
                _c("div", { staticClass: "aP-banner1-nameImgBar" }, [
                  _c("img", {
                    staticClass: "aP-banner1-nameImg aP-nameImg5",
                    attrs: { title: "", src: _vm.src5, alt: "" }
                  }),
                  _c("img", {
                    staticClass: "aP-banner1-nameImg aP-nameImg6",
                    attrs: { title: "", src: _vm.src6, alt: "" }
                  }),
                  _c("img", {
                    staticClass: "aP-banner1-nameImg aP-nameImg7",
                    attrs: { title: "", src: _vm.src7, alt: "" }
                  }),
                  _c("img", {
                    staticClass: "aP-banner1-nameImg aP-nameImg8",
                    attrs: { title: "", src: _vm.src8, alt: "" }
                  })
                ])
              ]),
              _vm._m(3),
              _vm._m(4)
            ])
          ])
        : _c("div", [_vm._m(5)]),
      _c("FooterNavigation")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "aboutProducts-banner5 positionRE" }, [
      _c("p", { staticClass: "font36px aP-banner-tlt" }, [
        _vm._v("健康瘦身 发现更好的自己")
      ]),
      _c("p", { staticClass: "aP-banner-p lineHeight17" }, [
        _vm._v(
          "\n          脂玫乐，专业健康瘦身品牌，主张辨证施法的健康瘦身理念，"
        ),
        _c("br"),
        _vm._v(
          "\n          组建名医研发团、技术顾问团和体脂督导团三大核心团队，"
        ),
        _c("br"),
        _vm._v("\n          创新提供 "),
        _c("b", [_vm._v("“体质管理+营养管理+作息管理”")]),
        _vm._v(" 三位一体的个性化健康瘦身方案和全程跟踪指导服务。"),
        _c("br"),
        _vm._v(
          "\n          创始以来，脂玫乐以“高效、健康、稳定”赢得了广大减肥客户的信赖与赞誉，树立了良好的市场口碑，"
        ),
        _c("br"),
        _vm._v(
          "\n          于2018年先后获评为“中国3.15诚信品牌”“湖南省创新创优·质量品牌双承诺单位”等荣誉,"
        ),
        _c("br"),
        _vm._v(
          "\n          是中国广受客户喜爱和拥有强势竞争力的健康瘦身品牌之一。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "aP-banner1-text" }, [
      _c("p", { staticClass: "font36px aP-banner-tlt" }, [
        _vm._v("湖南省中医药研究院 联合研制")
      ]),
      _c("p", { staticClass: "aP-banner-p" }, [
        _vm._v(
          "\n            建立700㎡湖南省中医药研究院战略合作研发实验室，特聘湖南省中医药研究院制剂室主任彭艳梅等权威专家为技术顾问， "
        ),
        _c("br"),
        _vm._v(
          "\n            在脂玫乐瘦身产品研发、技术公关、成果转化、工艺设备等方面给予指导与引领，助力脂玫乐产品研制的标准化、规范化。\n          "
        )
      ]),
      _c("p", { staticClass: "aP-banner-p aP-banner-p1" }, [
        _c("span", { staticClass: "aP-banner-name" }, [_vm._v("彭艳梅")]),
        _c("span", [
          _vm._v(
            "—— 湖南省中医药研究院制剂室主任、国家特殊医学用途配方食品审评专家、湖南省食品安全标准和风险评估专家委员会委员。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "aP-banner1-text" }, [
      _c("p", { staticClass: "font36px aP-banner-tlt" }, [
        _vm._v("名医研发团·健康瘦身名医配方")
      ]),
      _c("p", { staticClass: "aP-banner-p" }, [
        _vm._v(
          "\n            脂玫乐携手名老中医刘明汉、张良圣、谷井文以及膏方大师蒋孟良领衔的名医团队，深入研究经典古方、名方，精心改良适宜现代人体质和生"
        ),
        _c("br"),
        _vm._v("活环境的健康瘦身配方。\n          ")
      ]),
      _c("p", { staticClass: "aP-banner-p aP-banner-p2" }, [
        _c("span", { staticClass: "aP-banner-name" }, [_vm._v("刘明汉")]),
        _c("span", [
          _vm._v(
            "—国务院政府特殊津贴专家、全国卫生文明建设先进工作者、全国优秀卫生先进工作者"
          )
        ])
      ]),
      _c("p", { staticClass: "aP-banner-p aP-banner-p2" }, [
        _c("span", { staticClass: "aP-banner-name" }, [_vm._v("张良圣")]),
        _c("span", [
          _vm._v(
            "—全国先进工作者、全国卫生系统先进工作者、全国第五批名老中医药专家学术指导老师"
          )
        ])
      ]),
      _c("p", { staticClass: "aP-banner-p aP-banner-p2" }, [
        _c("span", { staticClass: "aP-banner-name" }, [_vm._v("谷井文")]),
        _c("span", [
          _vm._v(
            "—国务院政府特殊津贴专家、全国先进工作者、全国卫生系统先进工作者"
          )
        ])
      ]),
      _c("p", { staticClass: "aP-banner-p aP-banner-p2" }, [
        _c("span", { staticClass: "aP-banner-name" }, [_vm._v("蒋孟良")]),
        _c("span", [
          _vm._v(
            "—国家中医药管理局重点学科中药炮制学科带头人、国家中药炮制基地建设传承人、国家中医管理局中医药科技专家"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "aboutProducts-banner3 positionRE" }, [
      _c("div", { staticClass: "aP-banner1-text" }, [
        _c(
          "p",
          {
            staticClass: "font36px aP-banner-tlt",
            staticStyle: { color: "#ffffff" }
          },
          [_vm._v("国家药典标准精选 道地药材")]
        ),
        _c(
          "p",
          { staticClass: "aP-banner-p", staticStyle: { color: "#ffffff" } },
          [
            _vm._v(
              "\n            遵循道地药材的选材原则，从采购、验收等源头环节严控把关，所有原材均从全国正规药材厂选购，并由专业执业药师二次管控验收，以高达 "
            ),
            _c("br"),
            _vm._v(
              " 5%的拒收率，确保药材质量符合甚至高于国家药典、省炮制规范标准。\n          "
            )
          ]
        )
      ]),
      _c("div", { staticClass: "aP-banner3-bg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "aboutProducts-banner4 positionRE" }, [
      _c("div", { staticClass: "aP-banner1-text" }, [
        _c(
          "p",
          {
            staticClass: "font36px aP-banner-tlt",
            staticStyle: { color: "#282828" }
          },
          [_vm._v("产品版图")]
        ),
        _c(
          "p",
          { staticClass: "aP-banner-p", staticStyle: { color: "#282828" } },
          [
            _c("span", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v("品类：")
            ]),
            _c("span", [_vm._v("中医药食同源食品、保健品、OTC     ")]),
            _c("span", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v("剂型：")
            ]),
            _c("span", [_vm._v("膏滋、固体饮料、液态饮品、片剂")])
          ]
        )
      ]),
      _c("div", { staticClass: "aP-banner4-bg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phone-aboutProducts" }, [
      _c("div", { staticClass: "banner5-Box" }, [
        _c("div", { staticClass: "banner-tlt" }, [
          _vm._v("\n          健康瘦身 发现更好的自己\n        ")
        ]),
        _c("div", { staticClass: "banner5-text1 banner-textP" }, [
          _vm._v("\n          脂玫乐，专业健康瘦身品牌，"),
          _c("br"),
          _vm._v(
            "\n          主张辨证施法的健康瘦身理念，组建名医研发团、技术顾问团"
          ),
          _c("br"),
          _vm._v("\n          和体脂督导团三大核心团队，"),
          _c("br"),
          _vm._v("\n          创新提供“体质管理+营养管理+作息管理”三位一体"),
          _c("br"),
          _vm._v("\n          的个性化健康瘦身方案和全程跟踪指导服务。"),
          _c("br"),
          _vm._v("\n          创始以来，脂玫乐以“高效、健康、稳定”"),
          _c("br"),
          _vm._v(
            "\n          赢得了广大减肥客户的信赖与赞誉，树立了良好的市场口碑，"
          ),
          _c("br"),
          _vm._v("\n          于2018年先后获评为“中国3.15诚信品牌”"),
          _c("br"),
          _vm._v("\n          “湖南省创新创优·质量品牌双承诺单位”等荣誉,"),
          _c("br"),
          _vm._v(
            "\n          是中国广受客户喜爱和拥有强势竞争力的健康瘦身品牌之一。\n        "
          )
        ])
      ]),
      _c("div", { staticClass: "banner1-Box" }, [
        _c("div", { staticClass: "banner-tlt" }, [
          _vm._v("\n          湖南省中医药研究院"),
          _c("span", { staticClass: "col33333" }, [_vm._v(" - ")]),
          _vm._v("联合研制\n        ")
        ]),
        _c("div", { staticClass: "banner-textP banner1-text1" }, [
          _vm._v(
            "\n          建立700㎡湖南省中医药研究院战略合作研发实验室，\n          特聘湖南省中医药研究院制剂室主任彭艳梅等权威专家为技术顾问，在脂玫乐瘦身产品研发、技术公关、成果转化、工艺设备等方面给予指导与\n          引领，助力脂玫乐产品研制的标准化、规范化。\n        "
          )
        ]),
        _c("div", { staticClass: "banner1-imgBox" }),
        _c("div", { staticClass: "banner-textP banner1-text2" }, [
          _c("span", { staticClass: "col33333" }, [_vm._v("彭艳梅")]),
          _vm._v(
            "—— 湖南省中医药研究院制剂室主任、国家特殊医学用途配方食品审评专家、湖南省食品安全标准和风险评估专家委员会委员。"
          ),
          _c("br")
        ])
      ]),
      _c("div", { staticClass: "banner2-Box" }, [
        _c("div", { staticClass: "banner-tlt" }, [
          _vm._v("\n          名医研发团"),
          _c("span", { staticClass: "col33333" }, [_vm._v(" - ")]),
          _vm._v("健康瘦身名医配方\n        ")
        ]),
        _c("div", { staticClass: "banner-textP banner2-text1" }, [
          _vm._v(
            "\n          脂玫乐携手名老中医刘明汉、张良圣、谷井文以及膏方大师蒋孟良领衔的名医团队，深入研究经典古方、名方，精心改良适宜现代人体质和生活环境的健康瘦身配方。\n        "
          )
        ]),
        _c("div", { staticClass: "banner2-imgBox" }),
        _c("div", { staticClass: "banner-textP banner2-text2" }, [
          _c("span", { staticClass: "col33333" }, [_vm._v("刘明汉")]),
          _vm._v(
            "—— 国务院政府特殊津贴专家、全国卫生文明建设先进工作者、全国优秀卫生先进工作者"
          ),
          _c("br"),
          _c("span", { staticClass: "col33333" }, [_vm._v("张良圣")]),
          _vm._v(
            "—— 全国先进工作者、全国卫生系统先进工作者、全国第五批名老中医药专家学术指导老师"
          ),
          _c("br"),
          _c("span", { staticClass: "col33333" }, [_vm._v("谷井文")]),
          _vm._v(
            "—— 国务院政府特殊津贴专家、全国先进工作者、全国卫生系统先进工作者"
          ),
          _c("br"),
          _c("span", { staticClass: "col33333" }, [_vm._v("蒋孟良")]),
          _vm._v(
            "—— 国家中医药管理局重点学科中药炮制学科带头人、国家中药炮制基地建设传承人、国家中医管理局中医药科技专家"
          ),
          _c("br")
        ])
      ]),
      _c("div", { staticClass: "banner3-Box" }, [
        _c("div", { staticClass: "banner3-tlt" }, [
          _vm._v("\n          国家药典标准精选 "),
          _c("span", { staticClass: "col33333" }, [_vm._v("-")]),
          _vm._v(" 道地药材\n        ")
        ]),
        _c("div", { staticClass: "banner3-text" }, [
          _vm._v(
            "\n          遵循道地药材的选材原则，从采购、验收等源头\n          环节严控把关，所有原材均从全国正规药材厂选购，并由专业执业药师二次管控验收，以高达5%的拒收率，\n          确保药材质量符合甚至高于国家药典、省炮制规范标准。\n        "
          )
        ]),
        _c("div", { staticClass: "banner3-img" })
      ]),
      _c("div", { staticClass: "banner4-Box" }, [
        _c("div", { staticClass: "banner-tlt" }, [_vm._v("产品版图")]),
        _c("div", { staticClass: "banner-textP banner4-text" }, [
          _vm._v("\n          品类：中医药食同源食品、保健品、OTC "),
          _c("br"),
          _vm._v("\n          剂型：膏滋、固体饮料、液态饮品、片剂\n        ")
        ]),
        _c("div", { staticClass: "banner4-img" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d30ef82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d30ef82","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/aboutProducts/aboutProducts.vue
// module id = 1003
// module chunks = 17